export default "__VITE_ASSET__BWJReSqZ__"